/**
 * orga-app-api - veranstaltungen-v1-oa3_1
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpContext 
        }       from '@angular/common/http';
import { Observable }                                        from 'rxjs';
import { OpenApiHttpParams, QueryParamStyle } from '../query.params';

// @ts-ignore
import { FunkprotokollEintragRequest } from '../model/funkprotokollEintragRequest';
// @ts-ignore
import { FunkprotokollFallBildRequest } from '../model/funkprotokollFallBildRequest';
// @ts-ignore
import { FunkprotokollFallErfassenRequest } from '../model/funkprotokollFallErfassenRequest';
// @ts-ignore
import { FunkprotokollFallRequest } from '../model/funkprotokollFallRequest';
// @ts-ignore
import { FunkprotokollIdentifier } from '../model/funkprotokollIdentifier';
// @ts-ignore
import { FunkprotokollMandantOptions } from '../model/funkprotokollMandantOptions';
// @ts-ignore
import { FunkprotokollMeldeartDatenRequest } from '../model/funkprotokollMeldeartDatenRequest';
// @ts-ignore
import { FunkprotokollMeldeartIdentifier } from '../model/funkprotokollMeldeartIdentifier';
// @ts-ignore
import { FunkprotokollMeldeartRequest } from '../model/funkprotokollMeldeartRequest';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { BaseService } from '../api.base.service';



@Injectable({
  providedIn: 'root'
})
export class FunkprotokollCommandService extends BaseService {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: Configuration) {
        super(basePath, configuration);
    }

    /**
     * PostFunkprotokollEintragEntfernen
     * ORGA App Zugriff: * Mandant: ValidUser  Problem Types: * MandantIdFehlt: (MandantIdFehlt) * BenutzerNichtGefunden: (BenutzerNichtGefunden) * BenutzerNichtAktiviert: (BenutzerNichtAktiviert) * VeranstaltungNichtVeroeffentlicht: (VeranstaltungNichtVeroeffentlicht) * VeranstaltungBeendet: (VeranstaltungBeendet) * VeranstaltungGeloescht: (VeranstaltungGeloescht) * VerFunkprotokollKeineBerechtigung: (VeranstaltungFunkprotokollKeineBerechtigung) 
     * @endpoint post /api/ver/command/funkprotokoll/v1/eintrag/entfernen
     * @param funkprotokollEintragRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public postFunkprotokollEintragEntfernen(funkprotokollEintragRequest: FunkprotokollEintragRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<FunkprotokollIdentifier>;
    public postFunkprotokollEintragEntfernen(funkprotokollEintragRequest: FunkprotokollEintragRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<FunkprotokollIdentifier>>;
    public postFunkprotokollEintragEntfernen(funkprotokollEintragRequest: FunkprotokollEintragRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<FunkprotokollIdentifier>>;
    public postFunkprotokollEintragEntfernen(funkprotokollEintragRequest: FunkprotokollEintragRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (funkprotokollEintragRequest === null || funkprotokollEintragRequest === undefined) {
            throw new Error('Required parameter funkprotokollEintragRequest was null or undefined when calling postFunkprotokollEintragEntfernen.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/ver/command/funkprotokoll/v1/eintrag/entfernen`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<FunkprotokollIdentifier>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: funkprotokollEintragRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PostFunkprotokollEintragErfassen
     * ORGA App Zugriff: * Mandant: ValidUser  Problem Types: * MandantIdFehlt: (MandantIdFehlt) * BenutzerNichtGefunden: (BenutzerNichtGefunden) * BenutzerNichtAktiviert: (BenutzerNichtAktiviert) * VerFunkprotokollKeineBerechtigung: (VeranstaltungFunkprotokollKeineBerechtigung) 
     * @endpoint post /api/ver/command/funkprotokoll/v1/eintrag/erfassen
     * @param funkprotokollEintragRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public postFunkprotokollEintragErfassen(funkprotokollEintragRequest: FunkprotokollEintragRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<FunkprotokollIdentifier>;
    public postFunkprotokollEintragErfassen(funkprotokollEintragRequest: FunkprotokollEintragRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<FunkprotokollIdentifier>>;
    public postFunkprotokollEintragErfassen(funkprotokollEintragRequest: FunkprotokollEintragRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<FunkprotokollIdentifier>>;
    public postFunkprotokollEintragErfassen(funkprotokollEintragRequest: FunkprotokollEintragRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (funkprotokollEintragRequest === null || funkprotokollEintragRequest === undefined) {
            throw new Error('Required parameter funkprotokollEintragRequest was null or undefined when calling postFunkprotokollEintragErfassen.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/ver/command/funkprotokoll/v1/eintrag/erfassen`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<FunkprotokollIdentifier>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: funkprotokollEintragRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PostFunkprotokollFallAbschliessen
     * ORGA App Zugriff: * Mandant: ValidUser  Problem Types: * MandantIdFehlt: (MandantIdFehlt) * BenutzerNichtGefunden: (BenutzerNichtGefunden) * BenutzerNichtAktiviert: (BenutzerNichtAktiviert) * VeranstaltungNichtVeroeffentlicht: (VeranstaltungNichtVeroeffentlicht) * VeranstaltungBeendet: (VeranstaltungBeendet) * VeranstaltungGeloescht: (VeranstaltungGeloescht) * VerFunkprotokollKeineBerechtigung: (VeranstaltungFunkprotokollKeineBerechtigung) 
     * @endpoint post /api/ver/command/funkprotokoll/v1/fall/abschliessen
     * @param funkprotokollFallRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public postFunkprotokollFallAbschliessen(funkprotokollFallRequest: FunkprotokollFallRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<FunkprotokollIdentifier>;
    public postFunkprotokollFallAbschliessen(funkprotokollFallRequest: FunkprotokollFallRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<FunkprotokollIdentifier>>;
    public postFunkprotokollFallAbschliessen(funkprotokollFallRequest: FunkprotokollFallRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<FunkprotokollIdentifier>>;
    public postFunkprotokollFallAbschliessen(funkprotokollFallRequest: FunkprotokollFallRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (funkprotokollFallRequest === null || funkprotokollFallRequest === undefined) {
            throw new Error('Required parameter funkprotokollFallRequest was null or undefined when calling postFunkprotokollFallAbschliessen.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/ver/command/funkprotokoll/v1/fall/abschliessen`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<FunkprotokollIdentifier>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: funkprotokollFallRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PostFunkprotokollFallBildEntfernen
     * ORGA App Zugriff: * Mandant: ValidUser  Problem Types: * MandantIdFehlt: (MandantIdFehlt) * BenutzerNichtGefunden: (BenutzerNichtGefunden) * BenutzerNichtAktiviert: (BenutzerNichtAktiviert) * VeranstaltungNichtVeroeffentlicht: (VeranstaltungNichtVeroeffentlicht) * VeranstaltungBeendet: (VeranstaltungBeendet) * VeranstaltungGeloescht: (VeranstaltungGeloescht) * VerFunkprotokollKeineBerechtigung: (VeranstaltungFunkprotokollKeineBerechtigung) 
     * @endpoint post /api/ver/command/funkprotokoll/v1/fall/bild/entfernen
     * @param funkprotokollFallBildRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public postFunkprotokollFallBildEntfernen(funkprotokollFallBildRequest: FunkprotokollFallBildRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<FunkprotokollIdentifier>;
    public postFunkprotokollFallBildEntfernen(funkprotokollFallBildRequest: FunkprotokollFallBildRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<FunkprotokollIdentifier>>;
    public postFunkprotokollFallBildEntfernen(funkprotokollFallBildRequest: FunkprotokollFallBildRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<FunkprotokollIdentifier>>;
    public postFunkprotokollFallBildEntfernen(funkprotokollFallBildRequest: FunkprotokollFallBildRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (funkprotokollFallBildRequest === null || funkprotokollFallBildRequest === undefined) {
            throw new Error('Required parameter funkprotokollFallBildRequest was null or undefined when calling postFunkprotokollFallBildEntfernen.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/ver/command/funkprotokoll/v1/fall/bild/entfernen`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<FunkprotokollIdentifier>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: funkprotokollFallBildRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PostFunkprotokollFallBildHinzufuegen
     * ORGA App Zugriff: * Mandant: ValidUser  Problem Types: * MandantIdFehlt: (MandantIdFehlt) * BenutzerNichtGefunden: (BenutzerNichtGefunden) * BenutzerNichtAktiviert: (BenutzerNichtAktiviert) * VeranstaltungNichtVeroeffentlicht: (VeranstaltungNichtVeroeffentlicht) * VeranstaltungBeendet: (VeranstaltungBeendet) * VeranstaltungGeloescht: (VeranstaltungGeloescht) * VerFunkprotokollKeineBerechtigung: (VeranstaltungFunkprotokollKeineBerechtigung) 
     * @endpoint post /api/ver/command/funkprotokoll/v1/fall/bild/hinzufuegen
     * @param funkprotokollFallBildRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public postFunkprotokollFallBildHinzufuegen(funkprotokollFallBildRequest: FunkprotokollFallBildRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<FunkprotokollIdentifier>;
    public postFunkprotokollFallBildHinzufuegen(funkprotokollFallBildRequest: FunkprotokollFallBildRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<FunkprotokollIdentifier>>;
    public postFunkprotokollFallBildHinzufuegen(funkprotokollFallBildRequest: FunkprotokollFallBildRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<FunkprotokollIdentifier>>;
    public postFunkprotokollFallBildHinzufuegen(funkprotokollFallBildRequest: FunkprotokollFallBildRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (funkprotokollFallBildRequest === null || funkprotokollFallBildRequest === undefined) {
            throw new Error('Required parameter funkprotokollFallBildRequest was null or undefined when calling postFunkprotokollFallBildHinzufuegen.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/ver/command/funkprotokoll/v1/fall/bild/hinzufuegen`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<FunkprotokollIdentifier>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: funkprotokollFallBildRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PostFunkprotokollFallEntfernen
     * ORGA App Zugriff: * Mandant: ValidUser  Problem Types: * MandantIdFehlt: (MandantIdFehlt) * BenutzerNichtGefunden: (BenutzerNichtGefunden) * BenutzerNichtAktiviert: (BenutzerNichtAktiviert) * VeranstaltungNichtVeroeffentlicht: (VeranstaltungNichtVeroeffentlicht) * VeranstaltungBeendet: (VeranstaltungBeendet) * VeranstaltungGeloescht: (VeranstaltungGeloescht) * VerFunkprotokollKeineBerechtigung: (VeranstaltungFunkprotokollKeineBerechtigung) 
     * @endpoint post /api/ver/command/funkprotokoll/v1/fall/entfernen
     * @param funkprotokollFallRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public postFunkprotokollFallEntfernen(funkprotokollFallRequest: FunkprotokollFallRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<FunkprotokollIdentifier>;
    public postFunkprotokollFallEntfernen(funkprotokollFallRequest: FunkprotokollFallRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<FunkprotokollIdentifier>>;
    public postFunkprotokollFallEntfernen(funkprotokollFallRequest: FunkprotokollFallRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<FunkprotokollIdentifier>>;
    public postFunkprotokollFallEntfernen(funkprotokollFallRequest: FunkprotokollFallRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (funkprotokollFallRequest === null || funkprotokollFallRequest === undefined) {
            throw new Error('Required parameter funkprotokollFallRequest was null or undefined when calling postFunkprotokollFallEntfernen.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/ver/command/funkprotokoll/v1/fall/entfernen`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<FunkprotokollIdentifier>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: funkprotokollFallRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PostFunkprotokollFallErfassen
     * ORGA App Zugriff: * Mandant: ValidUser  Problem Types: * MandantIdFehlt: (MandantIdFehlt) * BenutzerNichtGefunden: (BenutzerNichtGefunden) * BenutzerNichtAktiviert: (BenutzerNichtAktiviert) * VerFunkprotokollKeineBerechtigung: (VeranstaltungFunkprotokollKeineBerechtigung) 
     * @endpoint post /api/ver/command/funkprotokoll/v1/fall/erfassen
     * @param funkprotokollFallErfassenRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public postFunkprotokollFallErfassen(funkprotokollFallErfassenRequest: FunkprotokollFallErfassenRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<FunkprotokollIdentifier>;
    public postFunkprotokollFallErfassen(funkprotokollFallErfassenRequest: FunkprotokollFallErfassenRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<FunkprotokollIdentifier>>;
    public postFunkprotokollFallErfassen(funkprotokollFallErfassenRequest: FunkprotokollFallErfassenRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<FunkprotokollIdentifier>>;
    public postFunkprotokollFallErfassen(funkprotokollFallErfassenRequest: FunkprotokollFallErfassenRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (funkprotokollFallErfassenRequest === null || funkprotokollFallErfassenRequest === undefined) {
            throw new Error('Required parameter funkprotokollFallErfassenRequest was null or undefined when calling postFunkprotokollFallErfassen.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/ver/command/funkprotokoll/v1/fall/erfassen`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<FunkprotokollIdentifier>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: funkprotokollFallErfassenRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PostFunkprotokollFallErinnerungSetzen
     * ORGA App Zugriff: * Mandant: ValidUser  Problem Types: * MandantIdFehlt: (MandantIdFehlt) * BenutzerNichtGefunden: (BenutzerNichtGefunden) * BenutzerNichtAktiviert: (BenutzerNichtAktiviert) * VeranstaltungNichtVeroeffentlicht: (VeranstaltungNichtVeroeffentlicht) * VeranstaltungBeendet: (VeranstaltungBeendet) * VeranstaltungGeloescht: (VeranstaltungGeloescht) * VerFunkprotokollKeineBerechtigung: (VeranstaltungFunkprotokollKeineBerechtigung) 
     * @endpoint post /api/ver/command/funkprotokoll/v1/fall/erinnerung
     * @param funkprotokollFallRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public postFunkprotokollFallErinnerungSetzen(funkprotokollFallRequest: FunkprotokollFallRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<FunkprotokollIdentifier>;
    public postFunkprotokollFallErinnerungSetzen(funkprotokollFallRequest: FunkprotokollFallRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<FunkprotokollIdentifier>>;
    public postFunkprotokollFallErinnerungSetzen(funkprotokollFallRequest: FunkprotokollFallRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<FunkprotokollIdentifier>>;
    public postFunkprotokollFallErinnerungSetzen(funkprotokollFallRequest: FunkprotokollFallRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (funkprotokollFallRequest === null || funkprotokollFallRequest === undefined) {
            throw new Error('Required parameter funkprotokollFallRequest was null or undefined when calling postFunkprotokollFallErinnerungSetzen.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/ver/command/funkprotokoll/v1/fall/erinnerung`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<FunkprotokollIdentifier>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: funkprotokollFallRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PostFunkprotokollFallReaktivieren
     * ORGA App Zugriff: * Mandant: ValidUser  Problem Types: * MandantIdFehlt: (MandantIdFehlt) * BenutzerNichtGefunden: (BenutzerNichtGefunden) * BenutzerNichtAktiviert: (BenutzerNichtAktiviert) * VeranstaltungNichtVeroeffentlicht: (VeranstaltungNichtVeroeffentlicht) * VeranstaltungBeendet: (VeranstaltungBeendet) * VeranstaltungGeloescht: (VeranstaltungGeloescht) * VerFunkprotokollKeineBerechtigung: (VeranstaltungFunkprotokollKeineBerechtigung) 
     * @endpoint post /api/ver/command/funkprotokoll/v1/fall/reaktivieren
     * @param funkprotokollFallRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public postFunkprotokollFallReaktivieren(funkprotokollFallRequest: FunkprotokollFallRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<FunkprotokollIdentifier>;
    public postFunkprotokollFallReaktivieren(funkprotokollFallRequest: FunkprotokollFallRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<FunkprotokollIdentifier>>;
    public postFunkprotokollFallReaktivieren(funkprotokollFallRequest: FunkprotokollFallRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<FunkprotokollIdentifier>>;
    public postFunkprotokollFallReaktivieren(funkprotokollFallRequest: FunkprotokollFallRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (funkprotokollFallRequest === null || funkprotokollFallRequest === undefined) {
            throw new Error('Required parameter funkprotokollFallRequest was null or undefined when calling postFunkprotokollFallReaktivieren.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/ver/command/funkprotokoll/v1/fall/reaktivieren`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<FunkprotokollIdentifier>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: funkprotokollFallRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PostFunkprotokollMandantOptionsSpeichern
     * ORGA App Zugriff: * Mandant: ValidUser  Problem Types: * MandantIdFehlt: (MandantIdFehlt) * BenutzerNichtGefunden: (BenutzerNichtGefunden) * BenutzerNichtAktiviert: (BenutzerNichtAktiviert) * VerFunkprotokollKeineBerechtigung: (VeranstaltungFunkprotokollKeineBerechtigung) 
     * @endpoint post /api/ver/command/funkprotokoll/v1/config/options
     * @param funkprotokollMandantOptions 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public postFunkprotokollMandantOptionsSpeichern(funkprotokollMandantOptions: FunkprotokollMandantOptions, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any>;
    public postFunkprotokollMandantOptionsSpeichern(funkprotokollMandantOptions: FunkprotokollMandantOptions, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<any>>;
    public postFunkprotokollMandantOptionsSpeichern(funkprotokollMandantOptions: FunkprotokollMandantOptions, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<any>>;
    public postFunkprotokollMandantOptionsSpeichern(funkprotokollMandantOptions: FunkprotokollMandantOptions, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (funkprotokollMandantOptions === null || funkprotokollMandantOptions === undefined) {
            throw new Error('Required parameter funkprotokollMandantOptions was null or undefined when calling postFunkprotokollMandantOptionsSpeichern.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/ver/command/funkprotokoll/v1/config/options`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<any>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: funkprotokollMandantOptions,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PostFunkprotokollMeldeartAktualisieren
     * ORGA App Zugriff: * Mandant: ValidUser  Problem Types: * MandantIdFehlt: (MandantIdFehlt) * BenutzerNichtGefunden: (BenutzerNichtGefunden) * BenutzerNichtAktiviert: (BenutzerNichtAktiviert) * KeinMandantAdminBerechtigung: (BenutzerKeinMandantAdmin) * VerFunkprotokollMeldeartNichtGefunden: (VeranstaltungFunkprotokollMeldeartNichtGefunden) * VerFunkprotokollMeldeartEntfernt: (VeranstaltungFunkprotokollMeldeartEntfernt) 
     * @endpoint post /api/ver/command/funkprotokoll/v1/meldeart/aktualisieren
     * @param funkprotokollMeldeartDatenRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public postFunkprotokollMeldeartAktualisieren(funkprotokollMeldeartDatenRequest: FunkprotokollMeldeartDatenRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<FunkprotokollMeldeartIdentifier>;
    public postFunkprotokollMeldeartAktualisieren(funkprotokollMeldeartDatenRequest: FunkprotokollMeldeartDatenRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<FunkprotokollMeldeartIdentifier>>;
    public postFunkprotokollMeldeartAktualisieren(funkprotokollMeldeartDatenRequest: FunkprotokollMeldeartDatenRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<FunkprotokollMeldeartIdentifier>>;
    public postFunkprotokollMeldeartAktualisieren(funkprotokollMeldeartDatenRequest: FunkprotokollMeldeartDatenRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (funkprotokollMeldeartDatenRequest === null || funkprotokollMeldeartDatenRequest === undefined) {
            throw new Error('Required parameter funkprotokollMeldeartDatenRequest was null or undefined when calling postFunkprotokollMeldeartAktualisieren.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/ver/command/funkprotokoll/v1/meldeart/aktualisieren`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<FunkprotokollMeldeartIdentifier>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: funkprotokollMeldeartDatenRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PostFunkprotokollMeldeartAnlegen
     * ORGA App Zugriff: * Mandant: ValidUser  Problem Types: * MandantIdFehlt: (MandantIdFehlt) * BenutzerNichtGefunden: (BenutzerNichtGefunden) * BenutzerNichtAktiviert: (BenutzerNichtAktiviert) * KeinMandantAdminBerechtigung: (BenutzerKeinMandantAdmin) 
     * @endpoint post /api/ver/command/funkprotokoll/v1/meldeart/anlegen
     * @param funkprotokollMeldeartDatenRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public postFunkprotokollMeldeartAnlegen(funkprotokollMeldeartDatenRequest: FunkprotokollMeldeartDatenRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<FunkprotokollMeldeartIdentifier>;
    public postFunkprotokollMeldeartAnlegen(funkprotokollMeldeartDatenRequest: FunkprotokollMeldeartDatenRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<FunkprotokollMeldeartIdentifier>>;
    public postFunkprotokollMeldeartAnlegen(funkprotokollMeldeartDatenRequest: FunkprotokollMeldeartDatenRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<FunkprotokollMeldeartIdentifier>>;
    public postFunkprotokollMeldeartAnlegen(funkprotokollMeldeartDatenRequest: FunkprotokollMeldeartDatenRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (funkprotokollMeldeartDatenRequest === null || funkprotokollMeldeartDatenRequest === undefined) {
            throw new Error('Required parameter funkprotokollMeldeartDatenRequest was null or undefined when calling postFunkprotokollMeldeartAnlegen.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/ver/command/funkprotokoll/v1/meldeart/anlegen`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<FunkprotokollMeldeartIdentifier>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: funkprotokollMeldeartDatenRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PostFunkprotokollMeldeartEntfernen
     * ORGA App Zugriff: * Mandant: ValidUser  Problem Types: * MandantIdFehlt: (MandantIdFehlt) * BenutzerNichtGefunden: (BenutzerNichtGefunden) * BenutzerNichtAktiviert: (BenutzerNichtAktiviert) * KeinMandantAdminBerechtigung: (BenutzerKeinMandantAdmin) * VerFunkprotokollMeldeartNichtGefunden: (VeranstaltungFunkprotokollMeldeartNichtGefunden) * VerFunkprotokollMeldeartEntfernt: (VeranstaltungFunkprotokollMeldeartEntfernt) 
     * @endpoint post /api/ver/command/funkprotokoll/v1/meldeart/entfernen
     * @param funkprotokollMeldeartRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public postFunkprotokollMeldeartEntfernen(funkprotokollMeldeartRequest: FunkprotokollMeldeartRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<FunkprotokollMeldeartIdentifier>;
    public postFunkprotokollMeldeartEntfernen(funkprotokollMeldeartRequest: FunkprotokollMeldeartRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<FunkprotokollMeldeartIdentifier>>;
    public postFunkprotokollMeldeartEntfernen(funkprotokollMeldeartRequest: FunkprotokollMeldeartRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<FunkprotokollMeldeartIdentifier>>;
    public postFunkprotokollMeldeartEntfernen(funkprotokollMeldeartRequest: FunkprotokollMeldeartRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (funkprotokollMeldeartRequest === null || funkprotokollMeldeartRequest === undefined) {
            throw new Error('Required parameter funkprotokollMeldeartRequest was null or undefined when calling postFunkprotokollMeldeartEntfernen.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/ver/command/funkprotokoll/v1/meldeart/entfernen`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<FunkprotokollMeldeartIdentifier>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: funkprotokollMeldeartRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

}
